import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { SimpleModal } from 'components/Shared';
import { Note } from 'components/Note';
import { ProjectTimeLineGraph } from '../ProjectTimelineGraph';

function ViewScheduleGraph() {
  const dispatch = useDispatch();
  const {
    viewScheduleGraph: {
      show = false,
      data: { overall = '0', timeline = {} },
    },
  } = useSelector(state => state.modal);

  return (
    <SimpleModal
      fullWidth
      maxWidth="lg"
      open={show}
      onClose={() => dispatch({ type: 'HIDE_SCHEDULE_GRAPH' })}
      classes="project-timeline-modal"
      displayCloseButton
    >
      <div className="tw-h-full">
        <div className="mt-n4">
          <h4 className="border-bottom modal-header py-xs-5">
            Schedule ({overall} weeks of design & fit-out)
          </h4>
        </div>
        <section className="tw-mt-4">
          {/* <div className="tw-bg-gray-100 tw-pb-4">
            <div className="tw-flex tw-justify-center tw-pt-4">
              <span className="tw-text-3xl bold">{overall} weeks</span>
            </div>
            <div className="tw-flex tw-justify-center">
              <span className="text-2-color bold">of design & fit-out</span>
            </div>
          </div> */}

          <div className="tw-pt-0">
            <ProjectTimeLineGraph schedule={{ overall, timeline }} displayHeading={false} />
          </div>
        </section>
        <Note page="projectTimeline" />
      </div>
    </SimpleModal>
  );
}

ViewScheduleGraph.protoTypes = {};

ViewScheduleGraph.defaultProps = {};

export { ViewScheduleGraph };
